import React, { useRef, useState, useEffect, useContext } from 'react'
import axios from '../../../../config/axios'
import { Container, OptionDiv, OptionText } from './style'
import UserContext from '../../../../contexts/UserContext'
import StockContext from '../../../../contexts/StockContext'

interface StockDropdwonMenu {
  text: string
  field: string
  onChange: (value: string) => void
}

/**
 * StockDropdown - Componente para seleção de valores de campos do estoque
 * 
 * IMPORTANTE: Para o campo "format", este componente apenas SELECIONA formatos existentes
 * e NÃO CRIA novos formatos. A tabela Format agora é global (não separada por tenant)
 * e os formatos devem ser gerenciados manualmente no banco de dados.
 * 
 * Caso precise adicionar novos formatos no futuro, isso deve ser feito diretamente
 * no banco de dados ou através de uma interface administrativa separada.
 */
const StockDropdown: React.FC<StockDropdwonMenu> = (props) => {
  const { token, user } = useContext(UserContext)
  const { stock, setStock } = useContext(StockContext)
  const [options, setOptions] = useState<string[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    if (!token || !props.field) return;
    
    let endpoint = ''
    if (props.field !== 'density') {
      endpoint = `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/${props.field}`
    } else {
      endpoint = `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/material/${props.field}`
    }
    
    setLoading(true)
    setError(false)
    
    const controller = new AbortController()
    
    axios
      .get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
        timeout: 10000,
      })
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : []
        setOptions(data)
        setError(false)
      })
      .catch((error) => {
        if (error.name !== 'CanceledError') {
          setOptions([])
          setError(true)
        }
      })
      .finally(() => {
        setLoading(false)
      })
    
    return () => {
      controller.abort()
    }
  }, [token, props.field])

  let filteredOptions = Array.isArray(options) ? options : []
  filteredOptions = filteredOptions.filter(
    (value) => value !== null && value !== '',
  )
  
  if (props.field !== 'format' && props.text !== '' && props.text !== null) {
    filteredOptions = filteredOptions.filter((str) =>
      str.toLowerCase().includes(props.text.toLowerCase()),
    )
  }

  if (loading) {
    return (
      <Container className="loading">
        <OptionText>Carregando...</OptionText>
      </Container>
    )
  }

  if (error) {
    return (
      <Container className="error">
        <OptionText>Erro ao carregar dados</OptionText>
      </Container>
    )
  }

  return (
    <Container
      onMouseDown={(e) => e.preventDefault()}
      className={filteredOptions.length == 0 ? 'empty' : ''}
    >
      {filteredOptions.map((header, index) => (
        <OptionDiv key={index} onClick={() => props.onChange(header)}>
          <OptionText>{header}</OptionText>
        </OptionDiv>
      ))}
    </Container>
  )
}

export default StockDropdown

